module.exports = __webpack_public_path__ + "img/logun_color.29e63d9b.svg";